import React, { useEffect, useState } from 'react'

const Timer = ({ counter, isPlaying, onChange, changeColorSeconds }) => {
  const [seconds, setSeconds] = useState(0)
  const [myInterval, setMyInterval] = useState(null)

  useEffect(() => {
    if (isPlaying && myInterval === null) {
      const interval = setInterval(() => {
        setSeconds(prevData => {
          return prevData + 1
        })
      }, 1000)
      setMyInterval(interval)
    } else if (!isPlaying && myInterval !== null) {
      clearInterval(myInterval)
      setMyInterval(null)
    }

    return () => {
      //clearInterval(myInterval)
      //setMyInterval(null)
    }
  }, [isPlaying, myInterval])

  useEffect(() => {
    onChange(seconds)
  }, [seconds, onChange])

  useEffect(() => {
    setSeconds(0)
  }, [counter])

  return (
    <div
      className={
        'myCircleTimer' + (seconds > changeColorSeconds ? ' danger' : '')
      }
    >
      {seconds}
    </div>
  )
}

export default Timer
